/**
 * 処理履歴を作成する
 * @param res
 * @returns statusBodyList
 */
function funStatusBodyList(res: any) {
  const statusBodyList: any[] = [];
  for (let i in res) {
    let createDate = new Date(res[i].createDate);
    const data = [
      {
        children: res[i].managerName,
      },
      {
        children: res[i].process,
      },
      {
        children:
          createDate.getFullYear() +
          "/" +
          (createDate.getMonth() + 1) +
          "/" +
          createDate.getDate(),
        align: "center",
      },
      {
        children: res[i].processComment,
      },
    ];
    statusBodyList.push(data);
  }

  return statusBodyList;
}

export { funStatusBodyList };
